module.exports = __webpack_public_path__ + "static/media/yelp_fullcolor_outline@2x.cac05e9d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/yelp-ratings/yelp_fullcolor_outline@2x.png
// module id = 1840
// module chunks = 0